export default "jenkins-file-artifactffa863534b26f298.svg"